import React from 'react';
import classnames from 'classnames';
import styles from './styles.scss';

const Text = (props) => {
  const { children, className, dataAaa, size, tag: Tag = 'div' } = props;

  const cn = classnames([className, styles.layout, styles[`size--${size}`]]);

  return (
    <Tag data-aaa={dataAaa} className={cn}>
      {children}
    </Tag>
  );
};

export default Text;
